import React, { useRef, useEffect } from "react";
import { Link } from "react-router-dom";

const HeroSection = () => {
  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.playbackRate = 0.4;
    }
  }, []);

  return (
    <section
      aria-label="AI powered SEO automation platform hero section"
      className="relative max-h-screen sm:min-h-screen w-full overflow-hidden bg-black"
    >

      {/* ================= STRUCTURED DATA ================= */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "SoftwareApplication",
            name: "Seo Up Rank",
            applicationCategory: "SEO Tool",
            operatingSystem: "Web",
            description:
              "AI powered SEO automation platform for automated SEO audits, keyword optimization, and website ranking improvement.",
            url: "https://novarsis.ai/",
          }),
        }}
      />

      {/* ================= HIDDEN SEO TEXT ================= */}
      <p className="sr-only">
        Seo Up Rank is an AI powered SEO automation platform that helps improve
        WordPress website rankings using AI analysis, automated SEO fixes,
        keyword optimization, and real-time SEO insights for organic traffic
        growth.
      </p>

      {/* ================= HIDDEN KEYWORDS ================= */}
      <p className="sr-only">
        AI SEO tool, website SEO optimization platform, automated SEO audit,
        WordPress SEO automation, AI keyword optimization tool, SEO analytics
        platform, on page SEO analysis tool.
      </p>

      {/* ================= INTERNAL LINKS FOR CRAWLERS ================= */}
      <div className="sr-only">
        <a href="/features">SEO Features</a>
        <a href="/tools">SEO Tools</a>
        <a href="/pricing">SEO Pricing</a>
        <a href="/blog">SEO Blog</a>
      </div>

      {/* ================= BACKGROUND VIDEO ================= */}
      <video
        ref={videoRef}
        className="absolute inset-0 w-full h-[100vh] object-cover"
        src="/Images/HOMESECTION.mp4"
        poster="/Images/HOMEPAGEPIC.png"
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
        aria-label="AI SEO automation dashboard background video"
      />

      {/* ================= IMAGE FALLBACK ================= */}
      <img
        src="/Images/HOMEPAGEPIC.png"
        alt="Seo Up Rank AI SEO automation dashboard interface"
        className="hidden"
      />

      {/* ================= CONTENT ================= */}
      <div className="relative z-10 flex min-h-screen items-center justify-center px-4 sm:px-6">
        <header
          className="
            text-center
            p-6 sm:p-8 md:p-12
            rounded-3xl
            shadow-2xl
            max-w-3xl w-full
          "
        >

          {/* ================= MAIN H1 ================= */}
          <h1
            className="
              text-2xl sm:text-3xl md:text-4xl lg:text-5xl
              font-extrabold
              text-white
              leading-tight
              mb-5
              backdrop-blur-[1px]
              rounded-full
              text-shadow-lg
              text-shadow-black
            "
          >
            AI-Powered <br />
            <span className="text-[#008300] text-shadow-lg text-shadow-black">
              SEO Automation Tool
            </span>{" "}
            for Faster Rankings
          </h1>

          {/* ================= SUPPORTING H2 ================= */}
          <h2 className="sr-only">
            WordPress SEO optimization with AI automation platform
          </h2>

          {/* ================= EXTRA SEO HEADING ================= */}
          <h2 className="sr-only">
            Automated SEO audits and keyword optimization tools
          </h2>

          {/* ================= SEO DESCRIPTION ================= */}
          <article>
            <p
              className="
                text-gray-200
                text-sm sm:text-base md:text-lg
                mb-8
                max-w-xl
                mx-auto
                text-center
                leading-relaxed
                backdrop-blur-[2px]
                rounded-full
                text-shadow-lg
                text-shadow-black
                font-semibold
              "
            >
              <strong>Seo Up Rank</strong> automates WordPress SEO using
              intelligent AI analysis and one-click optimization tools. Improve
              search engine rankings, increase organic traffic, and boost
              website visibility without technical complexity.
            </p>
          </article>

          {/* ================= CTA ================= */}
          <nav aria-label="Primary call to action">
            <Link to="/signin">
              <button
                aria-label="Explore Seo Up Rank AI SEO automation platform"
                className="
                  bg-[#008300]
                  hover:bg-green-600
                  px-6 sm:px-8 md:px-10
                  py-3 sm:py-4
                  rounded-full
                  text-white
                  text-sm sm:text-base md:text-lg
                  font-semibold
                  transition
                  hover:scale-105
                "
              >
                Explore SEO Tool
              </button>
            </Link>
          </nav>

        </header>
      </div>

    </section>
  );
};

export default HeroSection;